module.exports = __webpack_public_path__ + "img/08.4dd1d33f.jpg";